import React, { type PropsWithChildren, type ReactElement } from 'react';
import { Nav, NavItem } from 'reactstrap';
import SkeletonTabs from 'atom-components/skeleton/tabs/tabs';
import { LinkWithQuery } from 'feature-components/report-navigator/report-navigator';
import ReportFiltersSidebar from 'feature-components/reports/report-filters-sidebar';
import FilterSidebar from 'pages/clusters/subpages/aggregated-reports-tab/filter-sidebar';
import type { BaseReport } from 'services/assist-api/entities/reports/reports';
import styles from './cluster-report-layout.module.scss';

type ReportTabsProps = { reports: BaseReport[] };
function ReportTabs({ reports }: ReportTabsProps): ReactElement {
  return (
    <Nav tabs>
      {reports.map((report) => (
        <NavItem key={report.identifier}>
          <LinkWithQuery className="nav-link" to={report.identifier}>
            {report.name}
          </LinkWithQuery>
        </NavItem>
      ))}
    </Nav>
  );
}

function ReportLayout({ children }: PropsWithChildren): ReactElement {
  return <div className={styles.reportLayout}>{children}</div>;
}

function Report({ children }: PropsWithChildren): ReactElement {
  return <div className={styles.report}>{children}</div>;
}

export default Object.assign(ReportLayout, {
  Report: Object.assign(Report, {}),
  Tabs: Object.assign(ReportTabs, {
    Loading: () => <SkeletonTabs loading />,
    Error: () => <SkeletonTabs error />
  }),
  Sidebar: Object.assign(ReportFiltersSidebar, { CommonFilters: FilterSidebar })
});
